// extracted by mini-css-extract-plugin
module.exports = {"imageSkeleton":"ImageSkeleton_imageSkeleton__2KBIY","imageSkeletonIcon":"ImageSkeleton_imageSkeletonIcon__1z3a7","icon":"ImageSkeleton_icon__1ncxf"};